import { CalculationExample } from '../CalculationExample';

const MortgageNorwayCalculationExample: CalculationExample = {
  loanYears: 25,
  loanAmount: 2_100_000,
  interestRate: 0.0810,
  apr: 0.084,
  cost: 2_832_600,
  totalCost: 4_932_600,
  minInvoicingFee: 0.01,
  maxInvoicingFee: 0.04,
  updated: '2025-06-23',
};

export default MortgageNorwayCalculationExample;